import AppConfig from './domain/AppConfig';
import { BrowserUtil } from './BrowserUtil';
export const getEnvironment = () => {
    const domain = BrowserUtil.getHost();
    if (domain) {
        if (domain.indexOf('.local.') > -1 ||
            domain.indexOf('localhost') > -1 ||
            domain.includes('10.0.2.2')) {
            return AppConfig.ENV_LOCAL;
        }
        if (domain.indexOf('.test.') > -1) {
            return AppConfig.ENV_TEST;
        }
        if (domain.indexOf('.test2.') > -1) {
            return AppConfig.ENV_TEST_2;
        }
        if (domain.indexOf('.stg.') > -1) {
            return AppConfig.ENV_STG;
        }
        if (domain.indexOf('.local.') > -1) {
            return AppConfig.ENV_LOCAL;
        }
    }
    return AppConfig.ENV_PROD;
};
export const getBaseDomain = (env = getEnvironment()) => {
    const baseDomain = '.aperza.jp';
    if (env && env.length > 0) {
        return `.${env}${baseDomain}`;
    }
    return baseDomain;
};
export const getBaseComDomain = (env = getEnvironment()) => {
    const baseDomain = '.aperza.com';
    if (env && env.length > 0) {
        return `.${env}${baseDomain}`;
    }
    return baseDomain;
};
